import { normalizeError } from '../exception/utils';
import { MLP_ERROR_MESSAGE } from '../../constants/errorConstants';

export const normalizeServerError = (
  payload,
  errorMessage = MLP_ERROR_MESSAGE
) => {
  const err = normalizeError(payload, errorMessage);
  const errorObj = Array.isArray(payload.data.errors)
    ? payload.data.errors[0]
    : payload.data.errors;
  err.code = errorObj?.errorCode;
  return err;
};
